import React from 'react'
import { useTranslation } from 'react-i18next'
import { StatisticsDashboard } from '@cbgms/api/modules/statistics'
import GenericMonitorChart from './GenericMonitorChart'

const MonitorVehicleInvoicesChart: React.FC<{ data: StatisticsDashboard[] }> = props => {
  const { t } = useTranslation()

  return <GenericMonitorChart data={props.data} title={t('global.stats.vehicle_invoices')} dataSelector={row => row.TotalVehicleInvoices} />
}

export default MonitorVehicleInvoicesChart
